import type { TCargoType } from 'api/swagger';
import type { TComplexStatusType } from 'types/cargo';
import { createStore } from './create-store';

export interface ICargoFilter {
  orderId?: number;
  loadingPlaceCountryId?: number[];
  unloadingPlaceCountryId?: number[];

  loadingPlacePostCode?: string[];
  unloadingPlacePostCode?: string[];

  loadingPlaceName?: string[];
  unloadingPlaceName?: string[];

  loadingPlaceAddress?: string[];
  unloadingPlaceAddress?: string[];

  loadingDate?: {
    from: Date;
    to: Date;
  };

  cargoStatuses?: string[];

  type?: TCargoType;

  cmrNotReceived?: boolean;
  assetIsReturned?: boolean;

  deliveryTruckId?: number;

  complexStatusTypes?: TComplexStatusType[];
  complexWarehouseFilters?: string[];
}

type TState = {
  search: string;
  filters?: ICargoFilter;
};

type TActions = {
  setSearch: (value: string) => void;
  setFilters: (value: ICargoFilter | undefined) => void;
};

export const useCargoFiltersStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    filters: undefined,
    setSearch: (search: string) => set((state) => ({ ...state, search })),
    setFilters: (filters: ICargoFilter | undefined) => set((state) => ({ ...state, filters })),
  }),
  'cargos-filters-store',
);
